import FontAwesomeProIcon from '@ui/components/FontAwesomeProIcon/FontAwesomeProIcon';
import styles from '@ui/components/Alert/Alert.module.scss';
import Content from '@ui/components/Content/Content';
import Heading from '@ui/components/Heading/Heading';
import { Button as BaseButton } from '@ariakit/react';
import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { getHeadingTag } from '../../utils';

const Alert = ({
  title = null,
  details = null,
  icon = null,
  type,
  handleClose,
  hasCloseButton = false,
  headingLevel = 2,
  isElevated = false,
  className,
  ...props
}) => {
  const textTheme = type === 'neutral' ? 'default' : 'contrast';

  return (
    <div
      className={classNames(
        styles.container,
        styles[type],
        {
          [styles.elevated]: isElevated,
        },
        className,
      )}
      {...props}
    >
      <div className={styles.content}>
        <div className={styles.iconText}>
          {icon && (
            <FontAwesomeProIcon
              className={classNames(styles.icon)}
              icon={icon}
              role="presentation"
            />
          )}
          <div className={styles.title}>
            <Heading
              as={getHeadingTag(headingLevel)}
              noSpacing
              role="alert"
              size="h5"
              theme={textTheme}
            >
              {title}
            </Heading>
            {details && (
              <Content
                noSpacing
                role="alert"
                size="md"
                theme={textTheme}
                withParser
              >
                {details}
              </Content>
            )}
          </div>
        </div>
        {hasCloseButton && (
          <BaseButton
            aria-label="Alert schließen"
            className={styles.close}
            onClick={handleClose}
          >
            <FontAwesomeProIcon
              className={classNames(styles.closeIcon)}
              icon="times"
              role="presentation"
            />
          </BaseButton>
        )}
      </div>
    </div>
  );
};

Alert.propTypes = {
  details: PropTypes.string,
  handleClose: PropTypes.func,
  hasCloseButton: PropTypes.bool,
  icon: PropTypes.string,
  isElevated: PropTypes.bool,
  title: PropTypes.string,
  type: PropTypes.oneOf(['neutral', 'info', 'danger', 'success', 'warning'])
    .isRequired,
};

export default Alert;
